import { render } from "./SocialForm.vue?vue&type=template&id=4550abae"
import script from "./SocialForm.vue?vue&type=script&lang=js"
export * from "./SocialForm.vue?vue&type=script&lang=js"
script.render = render

export default script